module.exports = __webpack_public_path__ + "static/media/Star.5428fcd2.svg";